// NetworkLoadBalancerInfo.js
import React, { useState } from 'react';
import { Info, Image } from 'lucide-react';
import nlbPublicDiagram from '../assets/images/nlb-public.png';
import nlbPrivateDiagram from '../assets/images/nlb-private.png';

function NetworkLoadBalancerInfo({ type }) {
  const [isOpen, setIsOpen] = useState(false);
  const [showDiagram, setShowDiagram] = useState(false);

  const handleLearnMoreClick = () => {
    setIsOpen(true);
    setShowDiagram(false);
  };

  const handleDiagramClick = () => {
    setShowDiagram(true);
    setIsOpen(false);
  };

  const getDiagramImage = () => {
    return type === 'public' ? nlbPublicDiagram : nlbPrivateDiagram;
  };

  return (
    <div className="ml-auto flex gap-2">
      <button
        onClick={handleLearnMoreClick}
        className="flex items-center justify-center gap-1 w-custom px-3 py-3 rounded-lg hover:opacity-90 bg-green-600 text-white"
      >
        <Info size={16} />
        Learn More
      </button>
      <button
onClick={handleDiagramClick}
className="flex items-center justify-center gap-1 w-custom px-3 py-3 rounded-lg hover:opacity-90 bg-purple-600 text-white"
>
<Image size={16} />
Diagram
</button>

{isOpen && (
<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div className="bg-white rounded-xl shadow-xl p-8 m-4 max-w-3xl max-h-[90vh] overflow-y-auto">
    <div className="flex justify-between items-start mb-6">
      <div>
        <h3 className="text-2xl font-semibold text-gray-900 mb-2">
          {type === 'public' ? 'Internet Facing' : 'Private'} Network Load Balancer
        </h3>
        <p className="text-gray-600">Secure access and enhanced reliability for your server</p>
      </div>
      <button
        onClick={() => setIsOpen(false)}
        className="text-gray-400 hover:text-gray-600 text-2xl"
      >
        ×
      </button>
    </div>

    <div className="grid grid-cols-2 gap-6 mb-6">
      <div className="bg-green-50 border border-green-100 rounded-lg p-4">
        <h4 className="text-md font-medium text-green-900 mb-2">Benefits</h4>
        <ul className="space-y-2 text-sm text-green-800">
          <li>• Enables secure connections for external systems</li>
          <li>• Provides controlled access for client applications</li>
          <li>• Adds an extra layer of security</li>
          <li>• Faster recovery during incidents</li>
        </ul>
      </div>

      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
        <h4 className="text-md font-medium text-blue-900 mb-2">Key Features</h4>
        <ul className="space-y-2 text-sm text-blue-800">
          <li>• TCP/UDP protocol support</li>
          <li>• Static IP addresses</li>
          <li>• High availability</li>
          <li>• Low latency performance</li>
        </ul>
      </div>
    </div>
  </div>
</div>
)}

{showDiagram && (
<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div className="bg-white rounded-xl shadow-xl p-8 m-4 max-w-5xl max-h-[90vh] overflow-y-auto">
    <div className="flex justify-between items-start mb-6">
      <h3 className="text-2xl font-semibold text-gray-900">
        {type === 'public' ? 'Internet Facing' : 'Private'} NLB Architecture
      </h3>
      <button
        onClick={() => setShowDiagram(false)}
        className="text-gray-400 hover:text-gray-600 text-2xl"
      >
        ×
      </button>
    </div>
    <img 
      src={getDiagramImage()} 
      alt={`${type} NLB Architecture Diagram`}
      className="w-full h-auto"
    />
  </div>
</div>
)}
</div>
);
}

export default NetworkLoadBalancerInfo;